import styled from 'styled-components'

export const FavProject = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;

	.spin-fav-nic {
		display: flex;
		justify-content: center;
		align-items: center;
		align-content: center;
	}
`
